import React from "react";

interface BaseProps {
	value: string;
}

const OverflowTooltip = (props: BaseProps) => {
	const { value } = props;

	return (
		<div
			title={value}
			style={{
				whiteSpace: "nowrap",
				overflow: "hidden",
				textOverflow: "ellipsis",
			}}
		>
			{value}
		</div>
	);
};

export default OverflowTooltip;
